import { atom } from 'jotai';

export const openProductGraphsContainer = atom<boolean>(true);
